import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@comparethemarketau/manor-modal';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import { getBreakpointFromManor } from 'ctm-components';
import { CarDetails } from './details/car_details';
import { AccessoriesDetails } from './details/accessories_details';
import { CoverDetails } from './details/cover_details';
import { Address } from './details/address';
import { RegularDriver } from './details/regular_driver';
import { YoungerDriver } from './details/younger_driver';
import { DriverRestrictions } from './details/driver_restrictions';
import { ContactDetails } from './details/contact_details';
import { CommencementDate } from './details/commencement_date';

const useStyles = createUseStyles((theme) => ({
    yourQuoteDetailsModalContainer: {
        extend: ({ breakpoint }) => {
            if (breakpoint === 'md' || breakpoint === 'lg') {
                return {
                    padding: '0 3.9rem 0 1.7rem'
                };
            }
            if (breakpoint === 'sm') {
                return {
                    padding: '0 2.8rem 0 2.8rem'
                };
            }
            return {
                padding: '0'
            };
        }
    }
}));

const YourQuoteDetailsModal = (props) => {
    const { visible, onClose } = props;
    const theme = useContext(ThemeContext);
    const breakpoint = getBreakpointFromManor();
    const classes = useStyles({ theme, breakpoint });

    return (
        <Modal
            trackingLabel="Your Quote Details Modal"
            title="Your quote details"
            visible={visible}
            overlay
            handleClose={onClose}
            handleOverlayClick={onClose}
        >
            <div className={classes.yourQuoteDetailsModalContainer}>
                <CarDetails />
                <AccessoriesDetails />
                <CoverDetails />
                <Address />
                <RegularDriver />
                <YoungerDriver />
                <DriverRestrictions />
                <ContactDetails />
                <CommencementDate />
            </div>
        </Modal>
    );
};

YourQuoteDetailsModal.propTypes = {
    visible: PropTypes.bool,
    onClose: PropTypes.func
};

export { YourQuoteDetailsModal };
